/** Portal API Trip Tracer module base path (Backend Design Review). */
export const TRIP_TRACER_API_BASE_PATH = '/trip-tracer';

/** `avl_status` / `gtfs_status` values returned by GET /trip-tracer/avl-dates. */
export const AVL_STATUS = Object.freeze({
    SUPPORTED: 'supported',
    PARTIAL: 'partial',
    UNAVAILABLE: 'unavailable',
});

/**
 * Whether the portal agency can replay AVL in Trip Tracer, as derived from
 * the /avl-dates capability fields.
 */
export const TRIP_TRACER_AVAILABILITY = Object.freeze({
    IDLE: 'idle',
    LOADING: 'loading',
    ERROR: 'error',
    UNAVAILABLE: 'unavailable',
    PARTIAL: 'partial',
    SUPPORTED: 'supported',
});

/** `mode` for GET /trip-tracer/avl. Stage 1 is vehicle-first only. */
export const AVL_MODE = Object.freeze({
    VEHICLE: 'vehicle',
    ROUTE: 'route',
});

/** `coordinate_status` on each AVL observation. */
export const COORDINATE_STATUS = Object.freeze({
    VALID: 'valid',
    MISSING: 'missing',
    INVALID: 'invalid',
});

/** Server defaults and bounds for /avl sampling and the point cap. */
export const AVL_SAMPLE_SECONDS = Object.freeze({ DEFAULT: 30, MIN: 1, MAX: 300 });
export const AVL_MAX_POINTS = Object.freeze({ DEFAULT: 20000, MIN: 500, MAX: 50000 });

/** `capability` on a 409 TripTracerCapabilityConflictResponseDto. */
export const TRIP_TRACER_CAPABILITY = Object.freeze({
    AVL: 'avl',
    GTFS: 'gtfs',
});

/** Kinds in the normalized Trip Tracer error model. */
export const TRIP_TRACER_ERROR_KIND = Object.freeze({
    VALIDATION: 'validation',
    UNAUTHORIZED: 'unauthorized',
    FORBIDDEN: 'forbidden',
    NOT_FOUND: 'not_found',
    CAPABILITY: 'capability',
    TIMEOUT: 'timeout',
    SERVER: 'server',
    /** Any other 4xx. */
    REQUEST: 'request',
    NETWORK: 'network',
    CANCELED: 'canceled',
});

/** Path break kinds produced by the AVL adapter. */
export const PATH_BREAK_KIND = Object.freeze({
    TIME_GAP: 'time_gap',
    COORDINATE: 'coordinate',
});
